import axios from 'axios';
import ApiGet from '../../../sections/mainheader/apiget';


class RetailerWiseProductWiseSchemeService {

    constructor(apiUrl) {

        this.GetApiUrl = apiUrl;

        this.StatusOfRetailerProductWiseScheme = (payload) => (axios.post(`${this.GetApiUrl}RetailerProductWiseScheme/StatusOfRetailerProductWiseScheme`, payload));
        //   this.GetDetailsOfDynamicUIData = (Id) => (axios.get(`${this.GetApiUrl}SchemeConversionRate/GetSchemeConversionRateDetails/${Id}`));
        //   this.SearchFilter = (payload) => (axios.post(`${this.GetApiUrl}SearchFilter`, payload
        //   this.SearchFilter = (payload) => (axios.post(`${this.GetApiUrl}Scheme/SearchSchemeFilter`, payload));
        //   this.GetDynamicUISearchControls = () => (axios.get(`${this.GetApiUrl}SchemeConversionRate/GetSchemeConversionRateSearchControls`));
        this.GetRetailerWiseProductWiseSchemeSearchControls = () => (axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerProductWiseSchemeSearchControls`));
        this.GetRetailerWiseProductWiseSchemeReportSearchControls = () => (axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerProductWiseSchemeReportSearchControls`));
        this.GetRetailerProductCriteriaControl = () => (axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerProductCriteriaControl`));

        this.GetRetailerSlabMandatoryData = () => (axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerSlabMandatoryData`));
     // this.RetailerProductWiseDiscount = () => (axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerFilterReward/DiscountTypeExp`));
        this.RetailerProductWiseDiscount = () => (axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerFilterReward/RetailerProductWiseDiscount`));
        this.RetailerProductWiseFreeItem = () => (axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerFilterReward/FreeItem`));
        this.RetailerProductWiseGift = () => (axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerFilterReward/Gift`));

        this.GetRetailerProductClassificationControl = (payload) =>
            axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerProductClassificationControl/Item`);

        this.GetRetailerTargetClassificationControl = () =>
            axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerTargetClassificationControl/Item`);

        this.GetRetailerProductClassificationValueControl = (payload) =>
            axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerProductClassificationValueControl?TargetOn=Item&SchemeTargetClassification=${payload.SchemeTargetClassification}`);

        this.GetRetailerTargetClassificationValueControl = (payload) =>
            axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerTargetClassificationValueControl?TargetOn=Item&SchemeTargetClassification=${payload.SchemeTargetClassification}`);


        //   this.UpdateSchemeConversionRate = (payload) => (axios.post(`${this.GetApiUrl}SchemeConversionRate/UpdateSchemeConversionRate`, payload));
        this.DeleteRetailerProductWiseScheme = (id) => (axios.post(`${this.GetApiUrl}RetailerProductWiseScheme/DeleteRetailerProductWiseScheme/${id}`));
        this.RetailerProductSchemeApprovalRejection = (payload) => (axios.post(`${this.GetApiUrl}RetailerProductWiseScheme/RetailerProductSchemeApprovalRejection`, payload));
        this.GetRetailerProductClaimReport = (payload) => (axios.post(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerProductClaimReport`, payload));
        this.GetDetailsById = (id) => (axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetDetailsById`, { params: { Id: id } }));
        this.UpdateDetailsForRetailerProductScheme = (payload) => (axios.post(`${this.GetApiUrl}RetailerProductWiseScheme/UpdateDetailsForRetailerProductScheme`, payload));

        this.GetRuleBasedSchemeDataById = (schemeId) => axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetRuleBasedSchemeDataById`, { params : { SchemeId: schemeId }});

        this.SearchFilter = (payload) => (axios.post(`${this.GetApiUrl}Scheme/SearchSchemeFilter`, payload));
        this.GetRetailerProductWiseClaimReportSearchControls = (payload) => (axios.get(`${this.GetApiUrl}RetailerProductWiseScheme/GetRetailerProductWiseClaimeReportSearchControls`));

        this.getSchemesByGroupId = async (schemeGroupId, isRegeneration = false, isReport = false, isSchemeReport = false) => {
            try {

                const response = await axios.get(`${this.GetApiUrl}ApprovalProcess/getSchemesByGroupId/${schemeGroupId}`, {
                    params: { isRegeneration, isReport, isSchemeReport }
                });
                return response.data;
            } catch (error) {
                console.error('Error fetching schemes by group id:', error);
                throw error;
            }
        };

    }


}

export default ApiGet().then((apiUrl) => new RetailerWiseProductWiseSchemeService(apiUrl));

// [{ "Id": 10, "ApprovalFor": "Scheme", "IsApproved": true, "IsRejected": false, "Remark": "" }]